const category = 'AppSpecificIntake';

const cards = [
    {
        name: "Use Cases",
        id: "useCases",
        fields: [
            [{ id: "IntakeAcceptTempAuths" }],
            [{ id: "AllowContactDateOverride" }],
            [{ id: "ShouldPendAndReviewAbandoned" }],
            [{ id: "DisplayFCRAIntakeQns" }],
            [{ id: "IsAllowSpecificUsersToWithholdPCDefined" }],
            [{ id: "IntakeOrExternalClientUserAbleToWithholdPC" }],
            [{ id: "BackOfficeUserAbleToWithholdPC" }],
        ],
    },
    {
        name: "Allowed Transaction Type Configuration",
        id: "allowedTransactionType",
        fields: [
            [{ id: "CanIntakeAndExternalClientUsersAddTransactions" }],
            [
                {
                    id: "DefinedHistoryConditions",
                    layout: [
                        [
                            {
                                type: "group",
                                items: [
                                    {
                                        id: "NumDaysAvailableCreditHistory",
                                    },
                                    {
                                        id: "CreditHistoryStartDate",
                                    },
                                    {
                                        id: "NumDaysAvailableDebitHistory",
                                    },
                                    {
                                        id: "DebitHistoryStartDate",
                                    },
                                ],
                            },
                        ],
                    ],
                },
            ],
            [
                {
                    id: "DisputableTransactionTypeGroup",
                    layout: [
                        [
                            {
                                type: "group",
                                groupType: "checklist",
                                items: [
                                    {
                                        id: "DisputableTransactionTypeGroupACH",
                                    },
                                    {
                                        id: "DisputableTransactionTypeGroupATMDEP",
                                    },
                                    {
                                        id: "DisputableTransactionTypeGroupATMWD",
                                    },
                                    {
                                        id: "DisputableTransactionTypeGroupBalanceTransfer",
                                    },
                                    {
                                        id: "DisputableTransactionTypeGroupCardPinned",
                                    },
                                    {
                                        id: "DisputableTransactionTypeGroupCardPinless",
                                    },
                                    {
                                        id: "DisputableTransactionTypeGroupCHECK",
                                    },
                                    {
                                        id: "DisputableTransactionTypeGroupConvenienceCheck",
                                    },
                                    {
                                        id: "DisputableTransactionTypeGroupP2P",
                                    },
                                    {
                                        id: "DisputableTransactionTypeGroupRTPCredit",
                                    },
                                    {
                                        id: "DisputableTransactionTypeGroupRTPDebit",
                                    },
                                    {
                                        id: "DisputableTransactionTypeGroupWIRE",
                                    },
                                    {
                                        id: "DisputableTransactionTypeGroupZelle",
                                    },
                                ],
                            },
                        ],
                    ],
                },
            ],
        ],
    },
    {
        name: "Dispute Reasons Configuration",
        id: "disputeReasons",
        fields: [
            [
                {
                    type: "group",
                    groupType: "checklist",
                    id: "disputableReasonsConfig",
                    items: [
                        {
                            id: "ShowAccountTakeoverDisputeReason",
                        },
                        {
                            id: "AllowATOClaimsWithoutDisputedTrx",
                        },
                        {
                            id: "ShowMissingDepositDisputeReason",
                        },
                        {
                            id: "ShowFraudApplicationDisputeReason",
                        },
                    ],
                },
            ],
        ],
    },
    {
        name: "Plastic Mailing Address",
        id: "options",
        fields: [
            [
                {
                    type: "group",
                    groupType: "checklist",
                    id: "optionalCardBehavior",
                    label: "Select the optional issue card behavior that should be used.",
                    items: [
                        { id: "ShouldConfirmPlasticMailingAddress" },
                        { id: "CanMailPlasticToBranch" },
                    ],
                },
            ],
        ],
    },
    {
        name: "Questions",
        id: "questions",
        tooltip:
            "An optional question about an existing police report can be added during the claim interview for fraud claims. Select each of the applicable fraud questionnaires where the questions should be displayed.",
        fields: [
            [
                {
                    type: "group",
                    groupType: "checklist",
                    label: "Show Police Report Intake Questions For Claim Reason?",
                    id: "policeReportConfig",
                    items: [
                        {
                            id: "ShowPoliceReportQuestionForClaimReasonAccountTakeOver",
                        },
                        {
                            id: "ShowPoliceReportQuestionForClaimReasonFraudApp",
                        },
                        {
                            id: "ShowPoliceReportQuestionForClaimReasonCardLost",
                        },
                        {
                            id: "ShowPoliceReportQuestionForClaimReasonCardStolen",
                        },
                        {
                            id: "ShowPoliceReportQuestionForClaimReasonCardNotReceived",
                        },
                    ],
                },
            ],
        ],
    },
    {
        name: 'ACH Configuration',
        id: 'ACHConfiguration',
        fields: [
            [{ id: "EnableACHNonFraudRevokedInstructions" }],
            [{ id: "EnableIntakeChannelQuestion" }],
            [{ id: "ACHDocumentRequirementsTitle" }],
            [{ id: "BOACHTitleDocumentationRequirement" }],
        ]
    }
];

export { cards, category };